<div class="dynamic-field form-select col-12" [formGroup]="group">
    <div class="row">
      <div class="col-9 offset-3" style="margin-bottom: 5px;">
          <p-checkbox [formControlName]="config.name" binary="true" value="{{config.value}}" label="{{config.name}}" [disabled]=""></p-checkbox>
      </div>
    </div>
</div>